
import styles from '../style.module.css';

export default function BannerRotateItem({ value, text, background, valueColor, textColor, rotate, left = 0 }) {

    return (
        <div
            className={styles.banner_rotate_item}
            style={{
                background: background,
                transform: `rotate(${rotate}deg)`,
                marginLeft: `${left}px`
            }}
        >
            <h2 style = {{ color: valueColor }}>
                { value }
            </h2>
            <span style = {{ color: textColor }}>
                { text }
            </span>
        </div>
    )
}